/**
 * Migrates existing localStorage data to the authenticated user's
 * Supabase storage on first login. Ensures no data is lost.
 */

const STORAGE_KEYS = [
  'planner-data',
  'day-highlights',
  'day-notes',
  'monthly-goals',
  'daily-hours',
  'habits',
  'habit-tracking',
  'day-schedule',
  'day-tasks',
  'brain-dump',
  'todo-list'
];

export async function migrateLocalStorageToUser(userId, userStorage) {
  const migrationFlag = `migration-complete-${userId}`;

  // Skip if already migrated
  if (localStorage.getItem(migrationFlag) === 'true') {
    return { migrated: false, reason: 'already-done' };
  }

  let migratedCount = 0;

  for (const key of STORAGE_KEYS) {
    const localValue = localStorage.getItem(key);
    if (localValue) {
      try {
        // Only migrate if user doesn't already have this key in Supabase
        const existing = await userStorage.get(key);
        if (!existing || !existing.value) {
          await userStorage.set(key, localValue);
          migratedCount++;
        }
        // Remove old un-prefixed key after successful migration
        localStorage.removeItem(key);
      } catch (err) {
        console.error(`Migration error for key "${key}":`, err);
        // Leave the key in localStorage for retry on next login
      }
    }
  }

  localStorage.setItem(migrationFlag, 'true');
  return { migrated: true, count: migratedCount };
}
